// formats 1000 => 1k
export const humanizeNumber = (number) => {
  const decPlaces = Math.pow(10, 2);
  const abbrev = ["k", "m", "b", "t"];

  let i = abbrev.length - 1;

  while (i >= 0) {
    const size = Math.pow(10, (i + 1) * 3);
    if (size <= number) {
      number = Math.round((number * decPlaces) / size) / decPlaces;
      if (number === 1000 && i < abbrev.length - 1) {
        number = 1;
        i++;
      }
      number += abbrev[i];
      break;
    }
    i--;
  }
  return number;
};

export const stripCommas = (value) => {
  if (typeof value === "number") {
    return parseFloat(value.toString().replace(/,/g, ""));
  }
  if (typeof value === "string") {
    return parseFloat(value.replace(/,/g, ""));
  }
  return value;
};

export function commaNumber(number) {
  return (number || 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
